import React, { useState, useEffect } from 'react';
import { Dialog, Slide } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import usePostDataToServer from '../../hooks/usePostDataToServer';
import FormElement from '../../components/form/FormElement';
import CloseIcon from '@mui/icons-material/Close';
import Spinner from '../../components/spinner';
import { useContext } from 'react';
import AlertContext from '../../context/alerts';

function EditRoom({ singleData, open, onClose, onEdit }) {
    const { sendAlert } = useContext(AlertContext)
    const [roomTypeData, setRoomTypeData] = useState(singleData);
    const [isChanged, setIsChanged] = useState(false)
    const { setDataToServer, error } = usePostDataToServer("/updateRoomType", "listingRoomType", {
        onSuccessCb: (data) => {
            sendAlert(data?.message, "SUCCESS")
            onClose()
        },
        onErrorCb: (err) => {
            // console.log('error', err)
            sendAlert(err?.response?.data?.message, "ERROR")
        }
    })

    const handleUpdateInputs = (e) => {
        let value = e.target.value
        let data = {
            ...roomTypeData,
            [e.target.name]: value
        }
        setRoomTypeData(data)
        setIsChanged(true)
    }
    const handleSubmitForm = (e) => {
        e.preventDefault()
        let data = {
            typeName: roomTypeData.type_name,
            id: singleData.id
        }
        setDataToServer.mutate(data)
    }

    const handleClearAndCloseForm = (e) => {
        e.preventDefault()
        setRoomTypeData(singleData)
        onClose()
    }

    return (<Dialog fullWidth={true} maxWidth={'sm'} open={open} onClose={(e) => handleClearAndCloseForm(e)}>
        <div className='bg-white w-full px-5'>
            <div className='modal-head flex items-center justify-between'>
                <div className='mt-1.5'>
                    <h1 className='heading capitalize text-2xl'>Edit Room Type</h1>
                </div>
                <div>
                    <div onClick={onClose}>
                        <IconButton>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>

            </div>
            <form onSubmit={handleSubmitForm} className="py-7">
                <div className='flex justify-center space-x-48'>
                    <FormElement
                        label={'Room Type'}
                        placeholder={'e.g. classroom'}
                        element={'input'}
                        autocomplete={"off"}
                        name={'type_name'}
                        required={'required'}
                        errorMessage={'This is a Required Field'}
                        value={roomTypeData.type_name}
                        onChange={(e) => handleUpdateInputs(e)} />
                </div>
                {setDataToServer.isLoading ?
                    <Spinner /> : isChanged == true ?
                        <div className="flex justify-center mt-5">
                            <button
                                type='submit' className='text-white btn3'>Edit</button>
                        </div> : <div className="flex justify-center mt-5">
                            <button disabled
                                type='submit' className='text-white btn3 bg-blue-300'>Edit</button>
                        </div>}
                {error && <small className="text-red-700 font-semibold mt-1">{setDataToServer?.error?.response?.data?.message}</small>}
            </form>
        </div>
    </Dialog>
    )

}
export default EditRoom;